import * as React from 'react';
import { DateUtils } from '@grandvisionhq/utils';
import useActiveTimeFilters from '../../hooks/use-active-time-filters.js';
import { useAppointmentContext } from '../../pages/BookAppointment/context/AppointmentContext.js';

const useGetAvailabilityStoresNearbyQueryVariables = (date1)=>{
    const [{ getAvailabilityTimeFilters  }] = useActiveTimeFilters();
    const [, { store , type  }] = useAppointmentContext();
    return React.useMemo(()=>{
        if (!date1) {
            return undefined;
        }
        const { startTime , endTime  } = getAvailabilityTimeFilters(date1);
        const getHoursAndMinutes = (date)=>{
            const dateString = DateUtils.toLocalDateTime(date);
            const hours = dateString.split('T')[1].split(':')[0];
            const minutes = dateString.split('T')[1].split(':')[1];
            return `${hours}:${minutes}`;
        };
        const startTimeString = startTime ? getHoursAndMinutes(startTime) : undefined;
        const endTimeString = endTime ? getHoursAndMinutes(endTime) : undefined;
        /* if any of the required variants is missing, return
    undefined so that the query is not called */ return (type === null || type === void 0 ? void 0 : type.id) && (store === null || store === void 0 ? void 0 : store.lon) && (store === null || store === void 0 ? void 0 : store.lat) && date1 ? {
            appointmentTypeId: type.id,
            longitude: store.lon,
            latitude: store.lat,
            /* startDate is the selected date and endDate is
            one week later from startDate */ startDate: DateUtils.toLocalDate(date1).split('T')[0],
            endDate: DateUtils.toLocalDate(DateUtils.shiftDate(date1, 'week', 1)).split('T')[0],
            startTime: startTimeString,
            endTime: endTimeString
        } : undefined;
    }, [
        getAvailabilityTimeFilters,
        date1,
        type === null || type === void 0 ? void 0 : type.id,
        store === null || store === void 0 ? void 0 : store.lon,
        store === null || store === void 0 ? void 0 : store.lat
    ]);
};
var useGetAvailabilityStoresNearbyQueryVariables$1 = useGetAvailabilityStoresNearbyQueryVariables;

export { useGetAvailabilityStoresNearbyQueryVariables$1 as default };
//# sourceMappingURL=useGetAvailabilityStoresNearbyQueryVariables.js.map
